import { get as _get } from 'lodash';
import { EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import { fetchChatConfigApi, getChatAccessTokenApi, fetchNotificationApi, updateNotificationApi, fetchUserConfig, addTodoApi } from '../../api/Header';
import { CONSTANTS } from '../../constants/Constants';
import { getUserProfile, updateUserProfile, chatConfigUrl, getChatAccessTokenUrl, getUnreadNotificationsCount } from '../../api/urls';
import { notificationHelper, deepClone, isEmpty } from '../../utils/helper';
import { fetchUserDetailsApi, fetchUpdateUserDetailsApi } from '../../api/LeftNavApi';
import { NOTIFICATION_CONFIG, NUMBER_OF_ROWS } from '../Notifications/Constants';
import { getUniqueArrayofObjects } from '../../utils/helper.array';
import tapEvents, { HEADER_USER_FETCH } from '../../utils/tapEvents';
import { getManipulatedTodosForComponent } from '../Todo/Todo.helpers';
import { TODO_ACTIONS } from '../Todo/todo.constants';
import { toaster, TOASTER_TYPE } from '@tekion/tekion-components/src/organisms/NotificationWrapper';
import { getActiveTab } from '../../utils/helper.notification';
import TokenManager from '../../utils/TokenManager';
const {
  ACTIONS
} = CONSTANTS;
export const fetchGetUserDetails = baseUrl => dispatch => {
  const url = "".concat(baseUrl).concat(getUserProfile);
  dispatch({
    type: ACTIONS.SET_TICKET_LOADER,
    payload: {
      userDetails: true
    }
  });
  return fetchUserDetailsApi(url).then(response => {
    const {
      firstName,
      lastName
    } = response.data;
    if (firstName && lastName) {
      const userName = "".concat(firstName || '', " ").concat(lastName || '');
      TokenManager.setItem('uname', userName);
    }
    dispatch({
      type: ACTIONS.SET_TICKET_LOADER,
      payload: {
        userDetails: false
      }
    });
    dispatch({
      type: ACTIONS.FETCH_GET_USER_DETAILS_SUCCESS,
      payload: response
    });
    tapEvents.emit(HEADER_USER_FETCH, response.data);
  }).catch(error => {
    if (error.status) {
      const {
        status
      } = error;
      if (status === 440) {
        notificationHelper('error', __('Session Expired'), __('Session Expired. Redirecting to Sign in page.'));
      } else if (status === 401) {
        notificationHelper('warn', __('Unknown User'), __('Unknown user session. Redirecting to Sign in page.'));
      }
    } else {
      const event = new Event('fetchUserDetailsFailed');
      document.dispatchEvent(event);
      dispatch({
        type: ACTIONS.FETCH_GET_USER_DETAILS_ERROR,
        payload: error
      });
      dispatch({
        type: ACTIONS.SET_TICKET_LOADER,
        payload: {
          userDetails: false
        }
      });
      notificationHelper('error', __('Failed to fetch User Details'), ' ', 5, () => {}, '');
    }
  });
};
export const updateUserDetails = function (data, baseUrl) {
  let skipApiCall = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return dispatch => {
    if (skipApiCall) {
      dispatch({
        type: ACTIONS.FETCH_UPDATE_USER_DETAILS_SUCCESS,
        payload: data
      });
      return Promise.resolve(null);
    }
    const url = "".concat(baseUrl).concat(updateUserProfile);
    return fetchUpdateUserDetailsApi(url, data).then(() => {
      const userName = "".concat(data.firstName || '', " ").concat(data.lastName || '');
      TokenManager.setItem('uname', userName);
      dispatch({
        type: ACTIONS.FETCH_UPDATE_USER_DETAILS_SUCCESS,
        payload: data
      });
      notificationHelper('success', __('Successfully updated user profile'), ' ', 20, () => {}, '', 'bottomLeft');
    }).catch(error => {
      dispatch({
        type: ACTIONS.FETCH_UPDATE_USER_DETAILS_ERROR,
        payload: error
      });
      notificationHelper('error', __('Failed to update user profile'), ' ', 20, () => {}, '', 'bottomLeft');
    });
  };
};
export const resetAPISuccessEvent = () => dispatch => {
  dispatch({
    type: ACTIONS.RESET_USER_DETAIL_API_EVENT
  });
};
export const initUserEmail = () => dispatch => {
  const token = TokenManager.getItem(TokenManager.accessTokenKey);
  if (token) {
    const email = JSON.parse(atob(token.split('.')[1])).sub;
    dispatch({
      type: ACTIONS.SET_EMAIL,
      payload: email
    });
  }
};
export const fetchChatConfig = baseUrl => dispatch => {
  const url = "".concat(baseUrl).concat(chatConfigUrl);
  return fetchChatConfigApi(url).then(_ref => {
    let {
      data
    } = _ref;
    dispatch({
      type: ACTIONS.SET_CHAT_S3_URL,
      payload: data ? data.s3url : ''
    });
  });
};
export const getChatAccessToken = (baseUrl, data, callback) => () => {
  const url = "".concat(baseUrl).concat(getChatAccessTokenUrl);
  return getChatAccessTokenApi(url, data).then(_ref2 => {
    let {
      token
    } = _ref2;
    callback(token);
  });
};
export const fetchNotifications = (baseUrl, page, activeTab) => (dispatch, getState) => {
  const {
    url: apiURL,
    helper,
    getToken,
    tokenPropertyName
  } = NOTIFICATION_CONFIG[activeTab];
  const url = "".concat(baseUrl).concat(apiURL);
  dispatch({
    type: ACTIONS.NOTIFICATION_LOADING,
    payload: true
  });
  const notificationFilter = _get(getState(), 'header.notificationFilter', {});
  const data = isEmpty(notificationFilter) ? {
    start: page,
    rows: NUMBER_OF_ROWS
  } : {
    start: page,
    rows: NUMBER_OF_ROWS,
    filter: notificationFilter
  };
  const tokenInfo = {
    token: getToken(),
    tokenPropertyName
  };
  return fetchNotificationApi(url, data, tokenInfo).then(response => {
    const oldNotifications = _get(getState(), 'header.notifications', []);
    const newNotifications = deepClone(oldNotifications);
    const {
      notifications,
      count
    } = response;
    if (!isEmpty(notifications)) {
      const notificationItems = helper(notifications);
      newNotifications.push(...notificationItems);
      const hasMore = newNotifications.length < count;
      dispatch(setNotifications(getUniqueArrayofObjects(newNotifications, 'id')));
      dispatch(setNotificationHasMore(hasMore));
      dispatch({
        type: ACTIONS.NOTIFICATION_LOADING,
        payload: false
      });
    } else {
      dispatch(disableShowMore());
    }
  }).catch(() => {
    dispatch(disableShowMore());
  });
};
export const fetchUnreadNotificationsCount = function (baseUrl) {
  let notificationsBaseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_STRING;
  return dispatch => {
    const payload = {
      filter: {
        read: false
      }
    };
    let apiUrl = "".concat(baseUrl).concat(getUnreadNotificationsCount);
    const tokenInfo = {};
    if (!isEmpty(notificationsBaseUrl)) {
      const {
        url,
        getToken,
        tokenPropertyName
      } = NOTIFICATION_CONFIG[getActiveTab()];
      apiUrl = "".concat(notificationsBaseUrl).concat(url);
      tokenInfo.token = getToken();
      tokenInfo.tokenPropertyName = tokenPropertyName;
    }
    return fetchNotificationApi(apiUrl, payload, tokenInfo).then(response => {
      const {
        count
      } = response;
      dispatch(setUnreadNotificationCount(parseInt(count, 10)));
    });
  };
};
export const updateNotification = function (baseUrl, activeTab, data) {
  let allNotifications = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return (dispatch, getState) => {
    const {
      url: apiURL,
      getToken,
      tokenPropertyName
    } = NOTIFICATION_CONFIG[activeTab];
    const url = "".concat(baseUrl).concat(apiURL);
    const tokenInfo = {
      token: getToken(),
      tokenPropertyName
    };
    return updateNotificationApi(url, data, tokenInfo).then(() => {
      const notificationFilter = _get(getState(), 'header.notificationFilter', {});
      if (allNotifications && !isEmpty(notificationFilter)) {
        dispatch(setNotifications([]));
      }
    });
  };
};
export const disableShowMore = () => dispatch => {
  dispatch(setNotificationHasMore(false));
  dispatch({
    type: ACTIONS.NOTIFICATION_LOADING,
    payload: false
  });
};
export const setNotifications = data => dispatch => {
  dispatch({
    type: ACTIONS.FETCH_NOTIFICATIONS,
    payload: data
  });
};
export const setNotificationHasMore = data => dispatch => {
  dispatch({
    type: ACTIONS.HAS_MORE_NOTIFICATION,
    payload: data
  });
};
export const setNotificationFilter = data => dispatch => {
  dispatch({
    type: ACTIONS.NOTIFICATION_FILTER,
    payload: data
  });
};
export const setUnreadNotificationCount = data => dispatch => {
  dispatch({
    type: ACTIONS.SET_UNREAD_NOTIFICATIONS_COUNT,
    payload: data
  });
};
export const fetchUserTodos = apiBaseUrl => (dispatch, getState) => {
  const url = "".concat(apiBaseUrl, "/tapapi/userservice/v1/public/users/me");
  const {
    todos: todosFromRedux
  } = _get(getState(), 'header');
  if (isEmpty(todosFromRedux)) {
    dispatch({
      type: ACTIONS.SET_FETCH_TODO_LOADING,
      payload: true
    });
    return fetchUserConfig(url).then(response => {
      const {
        todos
      } = response;
      dispatch({
        type: ACTIONS.SET_TODO,
        payload: getManipulatedTodosForComponent(todos)
      });
      dispatch({
        type: ACTIONS.SET_FETCH_TODO_LOADING,
        payload: false
      });
    }).catch(err => {
      dispatch({
        type: ACTIONS.SET_FETCH_TODO_LOADING,
        payload: false
      });
    });
  }
};
export const addTodo = (apiBaseUrl, payload, actionType, callBack) => dispatch => {
  const url = "".concat(apiBaseUrl, "/tapapi/userservice/v1/public/users/me");
  return addTodoApi(url, payload).then(response => {
    const {
      todos
    } = response;
    dispatch({
      type: ACTIONS.SET_TODO,
      payload: getManipulatedTodosForComponent(todos)
    });
    switch (actionType) {
      case TODO_ACTIONS.TODO_ADD:
        toaster(TOASTER_TYPE.SUCCESS, __('TODO Created Successfully'));
        break;
      case TODO_ACTIONS.TODO_UPDATE:
        toaster(TOASTER_TYPE.SUCCESS, __('TODO Updated Successfully'));
        break;
      case TODO_ACTIONS.TODO_DELETE:
        toaster(TOASTER_TYPE.INFO, __('TODO Deleted Successfully'));
        break;
      default:
        return;
    }
    if (typeof callBack === 'function') {
      callBack();
    }
  });
};
export const setPusherCred = data => dispatch => {
  dispatch({
    type: ACTIONS.SET_PUSHER_CRED,
    payload: data
  });
};